import { createSelector } from "reselect"
import { forEach } from "lodash"

import { routeTemplates } from "../imports.jsx"
import matchPath from "@cirrus/legacy/app-common/alt/framework/matchPath.es6"

const getRouteData = (pathname, routeData, routeTemplates) => {
  if (pathname[0] != "/") {
    pathname = "/" + pathname
  }

  forEach(routeTemplates, (rt) => {
    let match = matchPath(pathname, { path: rt.config, exact: false })

    if (match != null) {
      if (match.isExact) {
        routeData.route = rt
        routeData.match = match
        return false
      } else if (rt.children != null) {
        getRouteData(pathname, routeData, rt.children)
      }
    }
  })
}

export const getRouteDataFromPathname = (pathname) => {
  let routeData = {
    route: {},
    match: null,
  }

  if (pathname == null) {
    return routeData
  }

  getRouteData(pathname, routeData, routeTemplates)

  return routeData
}

export default (pathnameSelector) => createSelector(pathnameSelector, getRouteDataFromPathname)
